import React from 'react';

import { Wrapper } from './PagePaddingContainer.styles';

interface IProps {
  children: React.ReactNode;
  className?: string;
  onScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
  scrollRef?: React.RefObject<HTMLDivElement | null>;
}

export const PagePaddingContainer: React.FC<IProps> = ({
  children,
  className,
  onScroll,
  scrollRef
}) => {
  return (
    <Wrapper ref={scrollRef} className={className} onScroll={onScroll}>
      {children}
    </Wrapper>
  );
};
